import React, { useEffect, useState } from 'react';
import Select from 'react-select';

export default function CitySelect({ department_id, onChange, style }) {
  const [cities, setCities] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);


  useEffect(() => {
    const fetchCities = async () => {
      try {
        // Fetching data from colombia.json (assuming it's in the public folder)
        const response = await fetch("/colombia.json");
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        
        // Find the department based on department_id
        const department = data.find(item => item.id === department_id);
        if (department) {
          // If department is found, set its cities to state
          setCities(department.ciudades);
        } else {
          setCities([]);
        }
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    fetchCities();
  }, [department_id]);

  const customStyle = {
    dropdownIndicator: (base, state) => ({
      ...base,
      transition: 'all .2s ease',
      transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null
    }),
    menu: (base, state) => ({
      height: "auto",
      backgroundColor: "white",
      zIndex: style ? 1000 : 0, // Add zIndex to ensure the dropdown appears on top
      position: style ? 'absolute' : "relative", // This helps to avoid affecting the layout below
      width: "100%",
      borderRadius: "10px"
    }),
    control: (base, state) => ({
      ...base,
      height: style ? style.height : "45px",
      borderColor: style ? style.borderColor : "#9EA3A5",
      boxShadow: style ? "none" : "",
      borderRadius: style ? style.rounded : "",
      '&:hover': {
                borderColor: style ? "none" : "", // Remove hover border
            },
    })
    // Add more styles as needed
  };

  // Map cities to options after sorting
  const options = cities.map(city => ({
    value: city,
    label: city,
  }));

  return (
    <div id="Ciudad" className="mb-4">
      <div className="relative w-full border-none">
        <Select
          name='ciudad_meta_ads'
          id='ciudad_meta_ads'
          value={selectedOption}
          onChange={option => {
            setSelectedOption(option);
            onChange(option.value); // Call the onChange handler with the selected value
          }}
          options={options}
          styles={customStyle}
          className="h-50"
          placeholder="Seleccione una ciudad"
          required
        />
      </div>
    </div>
  );
}
